import gql from 'graphql-tag';
import { ECHELON_INFO_FRAGMENT } from '../echelon/fragment';
import { ENTITY_FRAGMENT } from '../entity/fragment';
import { ENSEIGNE_INFO_FRAGMENT } from './fragment';

export const CREATE_ENSEIGNE = gql`
  mutation CreateEnseigne($input: CreateEnseigneInput!) {
    createEnseigne(input: $input) {
      ...EnseigneInfo
      entities {
        ...EntityInfo
        echelon {
          ...EchelonInfo
        }
      }
    }
  }
  ${ENSEIGNE_INFO_FRAGMENT}
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
`;

export const UPDATE_ENSEIGNE = gql`
  mutation UpdateEnseigne($input: UpdateEnseigneInput!) {
    updateEnseigne(input: $input) {
      ...EnseigneInfo
      entities {
        ...EntityInfo
        echelon {
          ...EchelonInfo
        }
      }
    }
  }
  ${ENSEIGNE_INFO_FRAGMENT}
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
`;

export const DELETE_ENSEIGNE = gql`
  mutation DeleteEnseigne($input: DeleteEnseigneInput!) {
    deleteEnseigne(input: $input) {
      ...EnseigneInfo
      entities {
        ...EntityInfo
        echelon {
          ...EchelonInfo
        }
      }
    }
  }
  ${ENSEIGNE_INFO_FRAGMENT}
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
`;

export const IMPORT_ENSEIGNES = gql`
  mutation ImportEnseignes($input: ImportEnseignesInput!) {
    importEnseignes(input: $input)
  }
`;
